// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* news.css */
.news-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
  }

  h1{
    font-size: 5.3vw;
    margin-bottom: 20px;
    color:#555;
  }
  
  .error-message {
    color: red;
    font-weight: bold;
  }
  
  .news-articles {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 90%;
    max-width: 800px;
    opacity: 0.95;
  }
  
  .news-article {
    border: 1px solid #ccc;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    background: #f9f9f9;
  }
  
  .article-image {
    width: 150px;
    height: auto;
    object-fit: cover;
  }
  
  .article-content {
    padding: 1rem;
    flex: 1 1;
  }
  
  .read-more {
    color: #007bff;
    text-decoration: none;
    font-weight: bold;
    display: inline-block;
    margin-top: 8px;
  }
  
  .article-source,
  .article-published {
    font-size: 0.85rem;
    color: #666;
  }
  
  @media screen and (max-width: 768px) {
    .article-des{
      display: none;
    }
    
  }`, "",{"version":3,"sources":["webpack://./src/User/news.css"],"names":[],"mappings":"AAAA,aAAa;AACb;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,SAAO;EACT;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE;MACE,aAAa;IACf;;EAEF","sourcesContent":["/* news.css */\r\n.news-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding: 2rem;\r\n  }\r\n\r\n  h1{\r\n    font-size: 5.3vw;\r\n    margin-bottom: 20px;\r\n    color:#555;\r\n  }\r\n  \r\n  .error-message {\r\n    color: red;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .news-articles {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1.5rem;\r\n    width: 90%;\r\n    max-width: 800px;\r\n    opacity: 0.95;\r\n  }\r\n  \r\n  .news-article {\r\n    border: 1px solid #ccc;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: row;\r\n    background: #f9f9f9;\r\n  }\r\n  \r\n  .article-image {\r\n    width: 150px;\r\n    height: auto;\r\n    object-fit: cover;\r\n  }\r\n  \r\n  .article-content {\r\n    padding: 1rem;\r\n    flex: 1;\r\n  }\r\n  \r\n  .read-more {\r\n    color: #007bff;\r\n    text-decoration: none;\r\n    font-weight: bold;\r\n    display: inline-block;\r\n    margin-top: 8px;\r\n  }\r\n  \r\n  .article-source,\r\n  .article-published {\r\n    font-size: 0.85rem;\r\n    color: #666;\r\n  }\r\n  \r\n  @media screen and (max-width: 768px) {\r\n    .article-des{\r\n      display: none;\r\n    }\r\n    \r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
